var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderWrite = function SvgHeaderWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M18 1.5a4.47 4.47 0 0 1 3.182 1.318A4.47 4.47 0 0 1 22.5 6a4.47 4.47 0 0 1-1.318 3.182L7.864 22.5H1.5v-6.364L14.819 2.82h-.001A4.47 4.47 0 0 1 18 1.5m-2.651 2.91L4.053 15.703l4.244 4.243L19.592 8.652zm4.773-.531a3 3 0 0 1 .454 3.637l-4.092-4.092a3 3 0 0 1 3.638.455M7.229 21 3 16.772V21z",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderWrite;